import { generatedInvertedNrdsId } from "../../../util/serverUtil";

// Start - temp code we need to correct this PII data from API side
const encriptData = (data) => {
  if (data) {
    return generatedInvertedNrdsId(data);
  }
};

export const piiEncriptDecript = (target, ignoreElmentList) => {
  if (typeof target === "object") {
    for (const key in target) {
      if (Object.prototype.hasOwnProperty.call(target, key)) {
        if (typeof target[key] === "object" && ignoreElmentList.indexOf(key) < 1) {
          piiEncriptDecript(target[key], ignoreElmentList);
        } else {
          if (ignoreElmentList.indexOf(key) > -1) {
            if (key === "abbreviation") {
              target[key] = compress(target[key]);
            } else if (key === "member") {
              if (typeof target[key] === "object" && target[key].id) {
                target[key].id = compress(target[key].id);
              }
            } else if (key === "source") {
              if (Object.keys(target[key]).length === 1) {
                if (target[key] && target[key].agents.length > 0) {
                  target[key].agents.forEach((element) => {
                    if (element && element.agent_id) {
                      element.agent_id = compress(element.agent_id);
                      element.id = compress(element.id);
                    }
                  });
                }
              } else {
                piiEncriptDecript(target[key], ignoreElmentList);
              }
            } else if (key === "nrds_id") {
              target[key] = encriptData(target[key]);
            }
          }
        }
      }
    }
  }
};

export const compress = (string) => {
  string = encodeURIComponent(string);
  var newString = "",
    char,
    nextChar,
    combinedCharCode;
  for (var i = 0; i < string.length; i += 2) {
    char = string.charCodeAt(i);
    if (i + 1 < string.length) {
      nextChar = string.charCodeAt(i + 1) - 31;
      combinedCharCode = char + "" + nextChar.toLocaleString("en", { minimumIntegerDigits: 2 });
      newString += String.fromCharCode(parseInt(combinedCharCode, 10));
    } else {
      newString += string.charAt(i);
    }
  }
  return (
    "FAR_" +
    newString
      .split("")
      .reduce(
        (hex, c) =>
          (hex += c
            .charCodeAt(0)
            .toString(16)
            .padStart(4, "0")),
        "",
      )
      .toUpperCase()
  );
};

export const decompress = (strValue) => {
  if (strValue.split("FAR_").length > 1) {
    var string = strValue.split("FAR_")[1];
    var newString = "",
      char,
      codeStr,
      firstCharCode,
      lastCharCode;
    string = string
      .match(/.{1,4}/g)
      .reduce((acc, char) => acc + String.fromCharCode(parseInt(char, 16)), "");
    for (var i = 0; i < string.length; i++) {
      char = string.charCodeAt(i);
      if (char > 132) {
        codeStr = char.toString(10);
        firstCharCode = parseInt(codeStr.substring(0, codeStr.length - 2), 10);
        lastCharCode = parseInt(codeStr.substring(codeStr.length - 2, codeStr.length), 10) + 31;
        newString += String.fromCharCode(firstCharCode) + String.fromCharCode(lastCharCode);
      } else {
        newString += string.charAt(i);
      }
    }
    return decodeURIComponent(newString);
  } else {
    return strValue;
  }
};
// End - - temp code we need to correct this PII data from API side

export const removePropertiesFromResponse = (obj, keys) => {
  var index;
  for (var prop in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, prop)) {
      switch (typeof obj[prop]) {
        case "string":
        case "number":
          index = keys.indexOf(prop);
          if (index > -1) {
            delete obj[prop];
          }
          break;
        case "object":
          index = keys.indexOf(prop);
          if (Array.isArray(obj[prop])) {
            if (index > -1) {
              obj[prop] = [];
            } else {
              obj[prop].forEach((item) => {
                removePropertiesFromResponse(item, keys);
              });
            }
          } else {
            if (index > -1) {
              delete obj[prop];
            } else {
              removePropertiesFromResponse(obj[prop], keys);
            }
          }
          break;
      }
    }
  }
};
